"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Broadcast/CampaignPage/Body/MessagesTable/components/Table.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _RecipientTable = require('web/screens/Broadcast/RecipientTable'); var _RecipientTable2 = _interopRequireDefault(_RecipientTable);
var _TableHeader = require('./TableHeader'); var _TableHeader2 = _interopRequireDefault(_TableHeader);
var _Spinner = require('web/components/Spinner');

var _keyboard = require('web/services/keyboard');















/* The campaign page's recipients, in the shared table (Rev 29 Y3). */
const Table = ({
  onSetAllRowsSelection,
  areAnyRowsSelected,
  isLoading,
  hasItems,
  onAddPatients,
  columns,
  onMoveColumn,
  emptyLabel,
  page = 0,
  children,
}) => (
  _react2.default.createElement(_RecipientTable2.default, {
    selectAll: { isChecked: areAnyRowsSelected, onChange: onSetAllRowsSelection },
    variableHeaders: _react2.default.createElement(_TableHeader2.default, { columns: columns, onMoveColumn: onMoveColumn, __self: this, __source: {fileName: _jsxFileName, lineNumber: 38}} ),
    variableCount: columns.length,
    hasItems: hasItems,
    page: page,
    emptyState: isLoading
      ? _react2.default.createElement(_Spinner.SimpleSpinner, { className: "campaign--table--spinner", __self: this, __source: {fileName: _jsxFileName, lineNumber: 43}} )
      : _nullishCoalesce(emptyLabel, () => ( (
        _react2.default.createElement(_react2.default.Fragment, null, "To get started, "

          , _react2.default.createElement('span', { role: "button", tabIndex: 0, onKeyDown: _keyboard.onButtonKeyDown, onClick: onAddPatients, __self: this, __source: {fileName: _jsxFileName, lineNumber: 47}}, "add patients" ), "."
        )
      )))
    , __self: this, __source: {fileName: _jsxFileName, lineNumber: 36}}

    ,  children 
  )
)

exports. default = Table
